import { useCommentsConfig } from "./Provider/ConfigContext";
import { useCommentsSection } from "./Provider/SectionContext";

export const useIsCommentsSectionVisible = (): boolean => {
  const { isCommentsEnabled } = useCommentsConfig();
  const { isCommentsOpen } = useCommentsSection();
  return isCommentsEnabled && isCommentsOpen;
};
